// Barrel re-export — all consumers import from here
// e.g. import { deviceApi, api } from '../services/api';

export { api } from './client';
export { default } from './client';

export { authApi } from './auth';
export { deviceApi } from './devices';
export { alarmApi } from './alarms';
export { siteApi } from './sites';
export { zoneApi } from './zones';
export { notificationApi } from './notifications';
export { userApi } from './users';
export { dashboardApi } from './dashboard';
export { sensorProvisioningApi } from './sensorProvisioning';
export { kioskApi } from './kiosks';
export type { Kiosk, KioskScreenshot } from './kiosks';
export { meetingRoomsApi } from './meetingRooms';
export type { MeetingEvent, MeetingRoom } from './meetingRooms';
